import {
  headline,
  spacer,
  button,
  field,
  text,
} from '@components/Widgets/_contentItems/all'
import { settings, styling } from '@components/Widgets/Templates/_base'
import { position, type, maxWidth } from '@meta/widget/options'
import { tag, typeTag } from '@meta/widget/templates'

const info = {
  name: 'Trends Signup',
  templateID: '5',
  description: 'Simplify the sign-up process with the "Trends Signup" widget. This streamlined design ensures users can quickly and easily enter their information, making it perfect for newsletter subscriptions and lead generation.',
  tags: [typeTag.FLYOUT, tag.LEAD_GENERATION],
}

const json = {
  id: 2038764,
  templateID: info.templateID,
  type: type.COLUMN,
  name: info.name,
  active: true,
  settings: (() => {
    const customSettings = { ...settings }
    customSettings.position = position.CENTER
    customSettings.ribbonColor = 'rgba(242, 248, 248, 1)'
    customSettings.closeButton = false
    customSettings.closeButtonColor = 'rgba(242, 248, 248, 1)'
    return customSettings
  })(),
  styling: (() => {
    const customStyling = { ...styling } // Ensure we're working with a copy of the styling
    customStyling.backgroundColor = 'rgb(173, 179, 179)'
    customStyling.maxWidth = maxWidth.MEDIUM
    return customStyling
  })(),
  steps: [
    {
      id: '532i9h0',
      contentItems: [
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline)) // Deep copy for immutability
          customHeadline.content.text = 'Weekly Design Trends'
          Object.assign(customHeadline.styling, {
            color: 'rgba(242, 248, 248, 1)',
            fontSize: '32px',
            textAlign: 'left',
            fontFamily: 'Be Vietnam Pro',
            fontWeight: 'bold',
          })
          return customHeadline
        })(),
        (() => {
          const customText = JSON.parse(JSON.stringify(headline)) // Assuming it's similar to text structure
          customText.content.text = 'Join our audience and receive a newsletter packed with inspiration.'
          Object.assign(customText.styling, {
            color: 'rgba(242, 248, 248, 1)',
            fontSize: '20px',
            textAlign: 'left',
            fontFamily: 'Roboto',
            fontWeight: '400',
          })
          return customText
        })(),
        (() => {
          const customField = JSON.parse(JSON.stringify(field)) // Assuming it's similar to field structure
          customField.content.placeholder = 'Your Email Address'
          Object.assign(customField.styling, {
            color: 'rgb(0, 0, 0)',
            fontSize: '18px',
            textAlign: 'left',
            fontFamily: 'Roboto',
            fontWeight: '400',
            borderColor: '#000000',
            borderWidth: '0px',
            borderRadius: '0px',
            backgroundColor: 'rgba(242, 248, 248, 1)',
          })
          customField.settings.type = 'email'
          customField.settings.label = 'Email Field'
          customField.settings.required = true
          return customField
        })(),
        // spacer
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          customSpacer.styling.padding = '8px'
          return customSpacer
        })(),
        (() => {
          const customButton = JSON.parse(JSON.stringify(button))
          customButton.content.text = 'Subscribe'
          Object.assign(customButton.styling, {
            color: 'rgba(242, 248, 248, 1)',
            fontSize: '20px',
            fontFamily: 'Roboto',
            fontWeight: '400',
            borderColor: 'rgba(242, 248, 248, 1)',
            borderWidth: '2px',
            borderRadius: '4px',
            justifyContent: 'center',
            backgroundColor: 'rgba(173, 179, 179, 1)',
          })
          customButton.settings.action = 'next'
          customButton.settings.backBtn = false
          return customButton
        })(),
      ],
    },
    {
      id: 'tr2iwh0',
      contentItems: [
        // spacer
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          customSpacer.styling.padding = '30px'
          return customSpacer
        })(),
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'You\'re in!'
          Object.assign(customHeadline.styling, {
            fontFamily: 'Be Vietnam Pro',
            fontSize: '56px',
            fontWeight: 'normal',
            color: 'rgba(242, 248, 248, 1)',
            textAlign: 'center',
          })
          return customHeadline
        })(),
        (() => {
          const customText = JSON.parse(JSON.stringify(text))
          customText.content.text = '<p>We&#39;ll be in touch.</p>'
          Object.assign(customText.styling, {
            fontFamily: "Roboto",
            fontSize: "24px",
            fontWeight: "400",
            color: "rgba(242, 248, 248, 1)",
            textAlign: "center"
          })
          return customText
        })(),
        // spacer
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          customSpacer.styling.padding = '40px'
          return customSpacer
        })(),
      ],
    },
  ],
}

export { json, info }
